import { render, staticRenderFns } from "./NewsletterModal.vue?vue&type=template&id=83ace598"
import script from "./NewsletterModal.vue?vue&type=script&lang=js"
export * from "./NewsletterModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports